export default {
  likes: {
    en: 'Likes',
  },
  dislikes: {
    en: 'Could be better',
  },
}
